import React, {useEffect, useState} from "react";
import { Box, Typography,Divider, Grid,useMediaQuery } from "@mui/material";
import CustomTab from "components/Tabs/Tab";
import { useLocation } from "react-router-dom";
import PropertyDetails from "./propertyDetails";
import axios from "axios";
import { baseURL } from "services/API";
import HouseIcon from "@mui/icons-material/House";
import NearMeIcon from "@mui/icons-material/NearMe";
import { LocationCity } from "@mui/icons-material";
import Units from "./units";
import UnoccupiedUnits from "./unoccupiedUnits";
import Tickets from "scenes/Tickets";
import PropertyTenants from "./propertyTenants";
import PropertyDashboard from "./propertyDashboard";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentTab } from "state";
import PreviousTenants from "./previousTenants";
import SmartLocks from "./smartLocks";

const facilityIcons = {
  marginRight: "8px",
  fontSize: "20px",
  color: "#52524e",
};

const coloredIconGreen = {
  marginRight: "8px",
  fontSize: "20px",
  color: "#0af047",
};

const coloredIconRed = {
  marginRight: "8px",
  fontSize: "20px",
  color: "#f20a0a",
};

const detailsText = {
  fontSize: "16px",
  fontWeight: 600,
  padding: "5px",
};

const descriptionText = {
  fontSize: "15px",
  fontWeight: 400,
  fontStyle: "italic",
};




const PropertyDetailsTab = () => {
    const id  = useSelector((state) => state.property_id);
    const [value, setValue] = React.useState(useSelector((state)=> state.currentTab['propertyDetailsTab']) );
    const dispatch = useDispatch()
    const handleChange = (event, newValue) => {
      setValue(newValue);
      dispatch(setCurrentTab({ name: "propertyDetailsTab", tab: newValue }));
    };

    const [newChange, setNewChange] = useState(0)

    const isNonMobileScreen = useMediaQuery("(min-width:600px)");
    
    const [propertyDetails, setPropertyDetails] = useState({});
    const [rentalName, setRentalName] = useState("");
    const [propertyUse, setPropertyUse] = useState("");
    const [propertyLocation, setPropertyLocation] = useState("");
    const [locationCounty, setLocationCounty] = useState("");
    const [security, setSecurity] = useState("");
    const [hospitalAccess, setHospitalAccess] = useState("");
    const [roadAccess, setRoadAccess] = useState("");
    const [parking, setParking] = useState("");
    const [fibre, setFibre] = useState("");
    const [elevator, setElevator] = useState("");
    const [gym, setGym] = useState("");
    const [pool, setPool] = useState("");

    const fetchDetails = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/landlords/rentals/details?rental_id=${id}`
        );
        setPropertyDetails(response.data.data);
        setRentalName(response.data.data.rental_name);
        setPropertyUse(response.data.data.rental_type);
        setPropertyLocation(response.data.data.location);
        setLocationCounty(response.data.data.location_county);
        setSecurity(response.data.data.has24_security);
        setHospitalAccess(response.data.data.hospital_access);
        setRoadAccess(response.data.data.main_road_access);
        setParking(response.data.data.has_parking);
        setFibre(response.data.data.has_fibre);
        setElevator(response.data.data.has_elevator);
        setGym(response.data.data.has_gym);
        setPool(response.data.data.has_swimming_pool);
      } catch (e) {
        setPropertyDetails(true);
      }
    };

    useEffect(()=>{
        fetchDetails()
    }, [newChange])


    const tabComponents = [
      { Component: <PropertyDashboard handleChange={handleChange}/>, label: "Property Dashboard", index: 0 },
      { Component: <PropertyDetails propertyDetails={propertyDetails} newChange={newChange} setNewChange={setNewChange}/>, label: "Property Details", index: 1,},
      { Component: <Units propertyDetails={propertyDetails} />, label: "All Units", index: 2 },
      { Component: <PropertyTenants property_id={id}/>, label: "Current Tenants", index: 3 },
      { Component: <UnoccupiedUnits propertyDetails={propertyDetails}  property_id={id}/>, label: "Unoccupied Units", index: 4 },
      { Component: <SmartLocks propertyDetails={propertyDetails} />, label: "Smart Locks", index: 5 },
      { Component: <></>, label: "Rent Arrears", index: 6 },
      { Component: <Tickets ticketType={"rental_id"}/>, label: "Tickets", index: 7 },
      { Component: <PreviousTenants property_id={id}/>, label: "Previous Tenants", index: 8 },
      
    ]; 


    return (
      <Box >
        <Box sx={{ alignItems: "baseline", marginBottom: "0", width:"80%", margin:"0 0 0 0.5rem" }}>
            <Grid container sx={{ margin: "0.5rem  0 0 0.2rem" }}>
              <Grid item md={3.7} xs={5.8} sx={{ margin: "0.1rem" }}>
                <Box sx={{ display:"flex", flexDirection: "row" }}>
                  <HouseIcon sx={facilityIcons} />
                  <Typography sx={descriptionText}>Property Name: </Typography>
                </Box>
                <Typography sx={detailsText}>{rentalName}</Typography>
              </Grid>
              {isNonMobileScreen && 
                <>
                  <Divider orientation="vertical" variant="middle" flexItem />
                  <Grid item md={3.7} xs={5.8} sx={{ margin: "0.1rem" }}>
                    <Box sx={{ display:"flex", flexDirection: "row" }}>
                      <NearMeIcon sx={facilityIcons} />
                      <Typography sx={descriptionText}>Property Location:</Typography>
                    </Box>
                    <Typography sx={detailsText}>{propertyLocation}</Typography>
                  </Grid>
                </>
              }
              <Divider orientation="vertical" variant="middle" flexItem />
              <Grid item md={3.7} xs={5.8} sx={{ margin: "0.1rem" }}>
                <Box sx={{ display:"flex", flexDirection: "row" }}>
                  <LocationCity sx={facilityIcons} />
                  <Typography sx={descriptionText}>Location County:</Typography>
                </Box>
                <Typography sx={detailsText}>{locationCounty}</Typography>
              </Grid>
            </Grid>
        </Box>

        <Divider />
        <CustomTab tabComponents={tabComponents} value={value} handleChange={handleChange} />
      </Box>
    );

}

export default PropertyDetailsTab;